import { defineComponent as p, openBlock as l, createElementBlock as o, mergeProps as u, unref as e, renderSlot as m, createElementVNode as a, createCommentVNode as g } from "vue";
import { useScalarIcon as Z } from "../hooks/useScalarIcon.js";
const h = { key: 0 }, M = { key: 1 }, f = { key: 2 }, A = { key: 3 }, H = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconTerminal"
}, L = /* @__PURE__ */ p({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = Z(s);
    return (i, t) => (l(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      m(i.$slots, "default"),
      e(n) === "bold" ? (l(), o("g", h, t[0] || (t[0] = [
        a("path", { d: "M120,137,48,201A12,12,0,1,1,32,183l61.91-55L32,73A12,12,0,1,1,48,55l72,64A12,12,0,0,1,120,137Zm96,43H120a12,12,0,0,0,0,24h96a12,12,0,0,0,0-24Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (l(), o("g", M, t[1] || (t[1] = [
        a("path", {
          d: "M216,80V192H40V64H200A16,16,0,0,1,216,80Z",
          opacity: "0.2"
        }, null, -1),
        a("path", { d: "M117.31,134l-72,64a8,8,0,1,1-10.63-12L100,128,34.69,70A8,8,0,1,1,45.32,58l72,64a8,8,0,0,1,0,12ZM216,184H120a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : e(n) === "fill" ? (l(), o("g", f, t[2] || (t[2] = [
        a("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM77.66,173.66a8,8,0,0,1-11.32-11.32L100.69,128,66.34,93.66A8,8,0,0,1,77.66,82.34l40,40a8,8,0,0,1,0,11.32ZM192,176H128a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z" }, null, -1)
      ]))) : e(n) === "light" ? (l(), o("g", A, t[3] || (t[3] = [
        a("path", { d: "M116,132.48l-72,64a6,6,0,0,1-8-9L103,128,36,68.49a6,6,0,0,1,8-9l72,64a6,6,0,0,1,0,9ZM216,186H120a6,6,0,0,0,0,12h96a6,6,0,0,0,0-12Z" }, null, -1)
      ]))) : e(n) === "regular" ? (l(), o("g", H, t[4] || (t[4] = [
        a("path", { d: "M117.31,134l-72,64a8,8,0,1,1-10.63-12L100,128,34.69,70A8,8,0,1,1,45.32,58l72,64a8,8,0,0,1,0,12ZM216,184H120a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : e(n) === "thin" ? (l(), o("g", k, t[5] || (t[5] = [
        a("path", { d: "M116,128a4,4,0,0,1-1.34,3l-72,64a4,4,0,1,1-5.32-6L106,128,37.34,67a4,4,0,0,1,5.32-6l72,64A4,4,0,0,1,116,128Zm100,60H120a4,4,0,0,0,0,8h96a4,4,0,0,0,0-8Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  L as default
};
